// import { returnTypeHandler } from '@js/pages/returns/returnTypeHandler';
import { returnTypeListener } from '@js/pages/returns/returnTypeListener';
import { multiStepFormListener } from '@js/utilities/multi-step-form/multiStepFormListener';
// import { getObjectFromFormData } from '@js/utilities/formData';
// import { returnOrderProductsListHandler } from '@js/pages/returns/returnOrderProductsListHandler';
// import { returnTypeContentToggler } from '@js/pages/returns/returnTypeContentToggler';

import { returnModelsController } from '@js/pages/returns/returnModelsController';
import { returnSummary } from '@js/pages/returns/step5/returnSummary';
import '@js/pages/returns/services/return/serviceReturn';
import '@js/pages/returns/services/size-change/serviceSizeChange';
import '@js/pages/returns/services/engraving/serviceEngraving';
import '@js/pages/returns/services/exchange/serviceExchange';

import { returnsStarterFormHandler } from '@js/pages/returns/step1/returnsStarterFormHandler';

// import { parseJson } from '@js/utilities/response';
// import { openRemoteModal } from '@js/utilities/remoteModal';

import('@js/listeners/return/returnForm');

window.returnsFormElement = document.querySelector('#returns-form');

window.returnsFormData = {
    // serviceType
    // serviceProductType
    // newModel
};

multiStepFormListener();
returnsStarterFormHandler();
returnTypeListener();

// window.dispatchEvent(
//     new CustomEvent('return-type-set', {
//         detail: { returnType: 'service_exchange' },
//     })
// );

['DOMContentLoaded', 'RemoteContentLoaded'].forEach((ev) => {
    window.addEventListener(ev, () => {
        returnModelsController();
    });
});

// window.formStarterData = {};

// returnTypeHandler();
// multiStepFormListener();

// // step1

// const starterForm = document.querySelector('#returns-form-step-1');
const returnsForm = document.querySelector('#returns-form');

// const starterFormContainer = document.querySelector(
//     '#returns-form-starter-container'
// );
const returnsFormContainer = document.querySelector('#returns-form-container');
// const otherServicesContainer = document.querySelector(
//     '#returns-other-services'
// );
const weDoItForYouContainer = document.querySelector('#we-do-it-for-you-container');

const anyQuestionsContainer = document.querySelector('#any-questions-container');

// // step 1 remote content
// const step1ExchangeRemoteContentElement = document.querySelector(
//     '#returns-form-step-1-remote-content-exchange'
// );

// // step 2 order products list (return)
// const returnTypeOrderProductsListElement = document.querySelector(
//     '#returns-form-step-2-remote-content-return'
// );

// const orderIdInputElement = document.querySelector('.js-order-id-input');

// // console.log(returnsForm.multiStepForm);

// starterForm.addEventListener('submit', async (e) => {
//     e.preventDefault();

//     const formData = new FormData(starterForm);

//     window.formStarterData = getObjectFromFormData(formData);

//     console.log(window.formStarterData);

//     const response = await fetch(
//         `/api/issue/get_order_info?order_id=${window.formStarterData.order_id}&email=${window.formStarterData.email}`
//     );

//     const data = await parseJson(response);

//     window.formStarterResponse = data;

//     if (response.ok) {
//         // console.log('GIT');

//         returnOrderProductsListHandler(
//             data,
//             window.formStarterData.service_type
//         );

//         starterFormContainer.classList.add('d-none');
//         returnsFormContainer.classList.remove('d-none');
//         otherServicesContainer.classList.add('d-none');
//         weDoItForYOuContainer.classList.remove('d-none');
//         returnTypeContentToggler(window.formStarterData.service_type);

//         // if (window.formStarterData.service_type === 'service_exchange') {
//         //     step1ExchangeRemoteContentElement.loadRemoteContent();
//         // }

//         orderIdInputElement.value = window.formStarterData.order_id;

//         returnModelsController();
//     } else {
//         // console.log('ERROR');
//         openRemoteModal(
//             `/ajax/modals/error/default?custom_data_json=${JSON.stringify({
//                 ...data,
//                 phraseContext: starterForm.dataset.phraseContext,
//             })}`
//         );
//     }

//     // returnOrderProductsListHandler(window.formStarterData);
// });

returnsForm.addEventListener('multi-step-form.step.changed', (e) => {
    const { currentStep, lastStep } = e.detail;

    console.log(e.detail);

    // if (currentStep === 1) {
    //     returnOrderProductsListHandler(window.formStarterResponse);
    // }

    if (currentStep === lastStep) {
        returnSummary();
        weDoItForYouContainer?.classList.add('d-none');
        anyQuestionsContainer?.classList.remove('d-none');
    }

    returnsFormContainer.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
    });
});

// returnsForm.addEventListener('submit', ())

// ['DOMContentLoaded', 'RemoteContentLoaded'].forEach((ev) => {
//     window.addEventListener(ev, () => {
//         returnModelsController();
//         returnLengthHandler(
//             document.querySelector('.js-return-length:checked')?.value
//         );
//         returnTypeContentToggler(window.formStarterData.service_type);
//     });
// });
